export enum RiskRegister {
    Departmental = 0,
    Group = 1,
    Directorate = 2,
    OrgLevel3 = 3,
    Project = 4,
    Financial = 5
}